import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "empty"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.itemTargets.forEach(item => item.classList.remove("hidden"))
      this.emptyTarget.classList.add("hidden")
      return
    }

    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const question = item.dataset.question?.toLowerCase() || ""
      const answer = item.dataset.answer?.toLowerCase() || ""

      if (question.includes(query) || answer.includes(query)) {
        item.classList.remove("hidden")
        visibleCount++
      } else {
        item.classList.add("hidden")
      }
    })

    if (visibleCount === 0) {
      this.emptyTarget.classList.remove("hidden")
    } else {
      this.emptyTarget.classList.add("hidden")
    }
  }
}
